import { useTranslation } from 'react-i18next';
import CategoryProgressItem from './CategoryProgressItem';
import TrophyBadge from './TrophyBadge';
import {
  ListWrapper,
  Subtitle,
  RowsContainer,
  CategoryRow,
  ProgressCell,
  TrophyCell,
} from './styled-components';

const CategoryProgressList = ({
  categories,
  onCategoryClick,
}) => {
  const { t } = useTranslation('gamification');
  return (
    <ListWrapper>
      <Subtitle>{t('categoryProgressSubtitle')}</Subtitle>
      <RowsContainer>
        {categories.map((category) => (
          <CategoryRow key={category.id}>
            <ProgressCell>
              <CategoryProgressItem
                name={category.name}
                acquired={category.acquired}
                total={category.total}
                categoryId={category.id}
                trophyProgressBarColor={category.trophyProgressBarColor}
                onClick={
                  onCategoryClick
                    ? () => onCategoryClick(category)
                    : undefined
                }
              />
            </ProgressCell>
            <TrophyCell>
              <TrophyBadge categoryId={category.id} trophyColor={category.trophyNextLevelColor} bodyWidth={48} />
            </TrophyCell>
          </CategoryRow>
        ))}
      </RowsContainer>
    </ListWrapper>
  );
};

export default CategoryProgressList;
